<script setup lang="ts">
import type { Tab } from '~/composables/useTabs'
import { TheDataCard } from '#components'
import { NCollapseItem } from 'naive-ui'

const props = defineProps<{
  tab: Tab
  hideTitle?: boolean
  directive?: 'if' | 'show'
  as?: 'div' | 'card' | 'section'
  collapse?: boolean
}>()

const isShown = computed(() => (props.tab.current || props.tab.mode === 'scroll') && !props.tab.hidden)
</script>

<template>
  <component
    :is="props.as === 'card' ? TheDataCard : 'div'"
    v-if="directive === 'show' ? true : isShown"
    v-show="isShown"
    :id="tab.key"
    :class="props.collapse ? 'scroll-mt-[4.5rem]' : 'scroll-mt-20'"
  >
    <component :is="props.collapse ? NCollapseItem : 'div'" :name="tab.key" :display-directive="props.directive">
      <template v-if="props.collapse" #header>
        <TheSectionHeader v-if="!hideTitle" :label="tab.label" :icon="tab.icon" class="ml-1">
          <template #headerExtra>
            <slot name="headerExtra" />
          </template>
        </TheSectionHeader>
      </template>
      <TheSectionHeader v-if="!hideTitle && !props.collapse" :label="tab.label" :icon="tab.icon" :class="{ 'mb-4': as !== 'section' }">
        <template #headerExtra>
          <slot name="headerExtra" />
        </template>
      </TheSectionHeader>
      <slot />
    </component>
    <slot name="openers" />
  </component>
</template>
